import { axiosClient } from "./client"
import { EDIT_PROFILE } from "./client/endpoints"


const editProfile = async(data:any): Promise<any> => {
  try {
    const res = await axiosClient.post<any>(EDIT_PROFILE, data)
    return res.data
  } catch(err){
    return null
  }
}

const ProfileService = {
  editProfile,
}

export default ProfileService
